/* eslint-disable */
import { FILTER_START_DATE_SELECTED } from '../Filters.types';

/**
 * Action to update the start date for the filters
 * @param {Date} date The start date
 * @returns {ActionCreator<FromPayload<Date, ActionMeta, FILTER_START_DATE_SELECTED>>} The created `Action`
 */
const filtersStartDateSelected = (date) => ({ fromPayload }) => {
  return fromPayload(date, { debounce: true }, FILTER_START_DATE_SELECTED);
};

export default filtersStartDateSelected;
